export default __webpack_public_path__ + "resources/icons/n231-116e.png";